import React,{useState,useEffect} from 'react';
import {HashRouter as Router,Routes,Route} from 'react-router-dom';
import {AuthProvider} from './components/AuthProvider';
import {ChatbotProvider} from './components/ChatbotProvider';
import PromptBuilder from './components/PromptBuilder';
import StandaloneInstructions from './components/StandaloneInstructions';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import PWAStatus from './components/PWAStatus';
import PromptlyHelpChatbot from './components/PromptlyHelpChatbot';
import AIChatbot from './components/AIChatbot';
import NcbDebug from './pages/NcbDebug';
import NcbDiag from './pages/NcbDiag';
import ErrorPopup from './components/ErrorPopup';
import {onLog} from './lib/logBus';
import './App.css';

function App() {
const [globalError,setGlobalError]=useState(null);
useEffect(()=> {
const unsubscribe=onLog(entry=> {
if (entry.level==='error' && !globalError) {
const err=new Error(entry.message);
err.stack=entry.stack;
setGlobalError(err);
}
});
return ()=> unsubscribe();
},[globalError]);

return (
 <AuthProvider>
 <ChatbotProvider>
 <Router>
 <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
 <div className="fixed top-4 right-4 z-40">
 <PWAStatus />
 </div>
 <Routes>
 <Route path="/" element={<PromptBuilder />} />
 <Route path="/instructions" element={<StandaloneInstructions />} />
 <Route path="/ncb-debug" element={<NcbDebug />} />
 <Route path="/ncb-diag" element={<NcbDiag />} />
 </Routes>
 {globalError && <ErrorPopup error={globalError} onClose={()=> setGlobalError(null)} />}
 <PWAInstallPrompt />
 <AIChatbot isEnabled={false} />
 <PromptlyHelpChatbot />
 </div>
 </Router>
 </ChatbotProvider>
 </AuthProvider>
 );
}
export default App;